import { Grid, Skeleton } from "@mui/material";
import SortedItemsList, {
  ItemListElement,
} from "../../../../components/SortedItemsList/SortedItemsList";
import { Player, PlayerWithCount } from "../../../../services/shirts/types";
import FormatService from "../../../../services/formatService";
import defaultAvatar from "../../../../img/defaultProfile.jpg";
import { useEffect, useState } from "react";

interface TopPlayersProps {
  players: Array<PlayerWithCount>;
  pathAll: string;
  onClick: Function;
}

const TopPlayers = ({ players, pathAll, onClick }: TopPlayersProps) => {
  const title = "Most popular players";

  const [playerId, setPlayerId] = useState<number | undefined>(undefined);
  const [list, setList] = useState<Array<ItemListElement> | undefined>(
    undefined,
  );

  const { getPlayerName } = FormatService();

  useEffect(() => {
    setList(
      players
        .map((player) => {
          return {
            id: player.id,
            name: getPlayerName(player),
            value: player.appearances,
            img: player.picture,
          };
        })
        .sort((a, b) => b.value - a.value),
    );
  }, [players]);

  useEffect(() => {
    if (playerId !== undefined) {
      onClick(playerId);
    }
  }, [playerId]);

  const renderValue = (value: number) => {
    return String(value) + " shirts";
  };

  return list ? (
    <SortedItemsList
      list={list}
      title={title}
      renderValue={renderValue}
      defaultAvatarImg={defaultAvatar}
      fullListUrl={pathAll}
      onClick={setPlayerId}
      maxItems={5}
    />
  ) : (
    <Skeleton variant="rectangular" width={210} height={30} />
  );
};

export default TopPlayers;
